import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/thedesperatetrader/app/strategy/StrategyBrowseClient.tsx");
